import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import StaffLoading from "./StaffLoading";

export default function ProtectedRoute({ children }) {
  const { user, ready, claimsReady, profileReady, allowed, mustChangePassword } = useAuth();
  const loc = useLocation();
  if (!ready || (user && (!claimsReady || !profileReady))) return <StaffLoading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!allowed) return <Navigate to="/login?denied=1" replace />;
  if (mustChangePassword && loc.pathname !== "/account") return <Navigate to="/account" replace />;
  return children;
}
